export default function withBrandClient() {
  let {
    brandDuck
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line consistent-return
  return ctx => {
    let brand;

    // If we are on the server then ctx.req.brand should have been set
    // by the adapted brand express middleware that is run before this middleware
    if (ctx.req) {
      ({
        brand
      } = ctx.req);
    } else {
      // check query for brand parameter
      if (ctx.query.brand) {
        ({
          brand
        } = ctx.query);
      }

      // determine brand from existing application state
      if (!brand) {
        const state = ctx.store.getState();
        if (state && state.brand) {
          ({
            brand
          } = state);
        }
      }
    }

    // if no other brand can be detected then we default to 'atc'
    if (!brand) {
      brand = 'atc';
    }

    // assign it on the ctx data object
    ctx.data.brand = brand;

    // Set the brand Duck if we are given an instance
    if (brandDuck) {
      ctx.store.dispatch(brandDuck.creators.set(brand));
    } else {
      // Or attempt to dispatch a global action to update the brand value
      ctx.store.dispatch({
        type: '/brand/SET',
        payload: brand
      });
    }
  };
}